import { useTranslation } from 'react-i18next';
import type { AvatarFrame } from '../../../types/avatarFlow';
import styles from './Grid4x4.module.css';

export interface Grid4x4Props {
  frames: AvatarFrame[];
  onSelectFrame: (index: number) => void;
  testId?: string;
}

export function Grid4x4({ frames, onSelectFrame, testId = 'result-grid-4x4' }: Grid4x4Props): JSX.Element {
  const { t } = useTranslation('flows');
  return (
    <div className={styles.grid} role="list" data-testid={testId}>
      {frames.slice(0, 16).map((frame, index) => (
        <button
          key={frame.id}
          type="button"
          role="listitem"
          className={styles.cell}
          onClick={() => onSelectFrame(index)}
          data-testid={`result-grid-cell-${index}`}
          aria-label={t('avatarFlow.aria.frame', { n: index + 1 })}
        >
          <img src={frame.thumbnailUrl} alt="" className={styles.thumb} />
        </button>
      ))}
    </div>
  );
}
